import _asyncToGenerator from "D:/Projects/NET2/UJP/Ostalo/PorocevalskiPortal/PorocevalskiPortalApp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import InputWrapper from './common/InputWrapper.vue';
import InputText from './common/InputText.vue';
import { useApi } from '@/lib/api';
import { defineComponent, ref } from 'vue';
import { errorMap } from '@/lib/filters';
export default defineComponent({
  components: {
    InputWrapper: InputWrapper,
    InputText: InputText
  },
  props: {
    sifData: {}
  },
  setup: function setup(_, ctx) {
    var _api = useApi();

    var data = ref({});
    var item = ref();

    var submit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _api.post('clientWrite', data.value);

              case 2:
                res = _context.sent;

                if (res.status === 200) {
                  ctx.emit('added');
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function submit() {
        return _ref.apply(this, arguments);
      };
    }();

    return {
      data: data,
      submit: submit,
      errorMap: errorMap,
      item: item
    };
  }
});